import { AccordionSummary, Grid, Typography } from '@material-ui/core';
import Accordion from '@material-ui/core/Accordion';
import AccordionDetails from '@material-ui/core/AccordionDetails';
import EditIcon from '@material-ui/icons/Edit';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import VisibilityIcon from '@material-ui/icons/Visibility';
import MaterialTable from 'material-table';
import React, { useEffect, useMemo, useState } from 'react';
import { Link } from 'react-router-dom';
import Loading from '../../../../components/Loading';
import api from '../../../../services/api';
import { findPermission } from '../../../../services/auth';
import { canShowEdit } from '../../../../utils/functions';
import useStyles from '../style';
import { FilterStatusHeader } from './FilterStatusHeader';

export function Anchors({ providerId, isEditing }) {
  const classes = useStyles();

  const [providerAnchors, setProviderAnchors] = useState([]);
  const [status, setStatus] = useState('ativo');
  const [isLoading, setLoading] = useState(false);

  const memoizedTable = useMemo(
    () => (
      <MaterialTable
        localization={{
          body: {
            emptyDataSourceMessage: <span></span>,
          },
        }}
        className={classes.table}
        options={{
          showTitle: false,
          search: false,
          toolbar: false,
          headerStyle: {
            backgroundColor: '#F5F5F5',
            textTransform: 'none',
            fontSize: '15px',
          },
          filtering: true,
          paging: false,
        }}
        onRowClick={(event, rowData) => {
          if(!!findPermission(711, 'Alterar') && canShowEdit()) {
            window.location.href = window.location.origin + `/app/fornecedor/${providerId}/ancora/${rowData.fornecedorAncoraId}/editar`
          }
        }}
        title="Multiple Actions Preview"
        columns={[
          {
            title: 'Rede',
            field: 'ancora',
            cellStyle: {
              fontSize: '13px',
              padding: '8px 10px',
            },
          },
          {
            title: 'Nome Fantasia',
            field: 'nomeInterno',
            cellStyle: {
              fontSize: '13px',
              padding: '8px 16px',
            },
          },
          {
            title: 'Código interno',
            field: 'codigoInterno',
            cellStyle: {
              fontSize: '13px',
              padding: '8px 16px',
            },
          },
          {
            title: 'Status',
            field: 'status',
            cellStyle: {
              fontSize: '13px',
              padding: '8px 16px',
            },
          },
          {
            title: 'Ações',
            field: 'actions',
            headerStyle: {
              textAlign: 'center',
            },
            cellStyle: {
              fontSize: '13px',
              textAlign: 'center',
              padding: '8px 16px',
            },
            filtering: false,
            sorting: false,
            disableClick: true,
            render: (rowData) => (
              <>
                {!!findPermission(711, 'Consultar') && (
                  <Link
                    className={classes.buttonVisualize}
                    to={`/app/fornecedor/${providerId}/ancora/${rowData.fornecedorAncoraId}`}
                  >
                    <VisibilityIcon style={{ fontSize: 30, color: '#4AAF05' }} />
                  </Link>
                )}
                {!!findPermission(711, 'Alterar') && canShowEdit() && (
                  <Link
                    className={classes.buttonEdit}
                    to={`/app/fornecedor/${providerId}/ancora/${rowData.fornecedorAncoraId}/editar`}
                  >
                    <EditIcon style={{ fontSize: 30, color: '#FB8832' }} />
                  </Link>
                )}
              </>
            ),
          },
        ]}
        data={providerAnchors}
      />
    ),
    [providerAnchors],
  );

  const fetchAnchorsInfo = async () => {
    setLoading(true);
    const res = await api.get(
      `FornecedoresAncoras/ConsultarGridCadastro?fornecedorId=${providerId}&${
        status ? `status=${status}` : ''
      }`,
    );
    res.data.resposta?.[0]?.key === 'Notificacao' || res.data.resposta?.[0]?.key === ''
      ? setProviderAnchors([])
      : setProviderAnchors(res.data.resposta);
    setLoading(false);
  };

  useEffect(() => {
    if (providerId) {
      fetchAnchorsInfo();
    }
  }, [providerId]);

  return (
    <Accordion defaultExpanded>
      <AccordionSummary expandIcon={<ExpandMoreIcon />} className={classes.summary}>
        <Typography className={classes.heading}>Redes</Typography>
      </AccordionSummary>

      <AccordionDetails className={classes.details}>
        <Grid container>
          <Grid item xs={12} className={classes.registerBtn}>
            <FilterStatusHeader
              fetchFunc={fetchAnchorsInfo}
              status={status}
              setStatus={setStatus}
            />
            {!!findPermission(711, 'Cadastrar') && isEditing && (
              <Link
                className={classes.button}
                to={`/app/fornecedor/${providerId}/cadastrar-ancora`}
              >
                Novo Item
              </Link>
            )}
          </Grid>
          {isLoading ? (
            <Loading />
          ) : (
            <Grid item xs={12}>
              {memoizedTable}
            </Grid>
          )}
        </Grid>
      </AccordionDetails>
    </Accordion>
  );
}
